import { useContext } from 'react'

import { RequestDraft } from '../../../../context'

export function useRequestDraft() {
  return useContext(RequestDraft)
}
